import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable, inject } from '@angular/core';
import { mergeMap, withLatestFrom } from 'rxjs/operators';

import { Observable } from 'rxjs';
import { OrdFiltersActions } from './ord-filters.actions';
import { OrdSearchActions } from '../ord-search/ord-search.actions';
import { Store } from '@ngrx/store';
import ordFiltersReducer from './ord-filters.reducer';
import sharedEnvironmentReducer from '../shared-environment-info/shared-environment-info.reducer';

@Injectable()
export class OrdFilterEffects {
    private readonly actions$ = inject(Actions);
    private readonly appStore = inject(Store);

    private createLoadAction(filterGroups: any[], username?: string) {
        return OrdSearchActions.load({
            query: { filters: filterGroups, username },
        });
    }

    afterSet$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdFiltersActions.set),
        withLatestFrom(this.appStore.select(ordFiltersReducer.selectFilterGroups), this.appStore.select(sharedEnvironmentReducer.selectUsername)),
        mergeMap(([_action, filterGroups, username]) => {
            console.log('[ORD TRACE] OrdFiltersActions.set -> load', {
                at: new Date().toISOString(),
                username,
                activeFilters: filterGroups.filter((filterGroup) => filterGroup?.isActive).map((filterGroup) => filterGroup.key),
            });
            return [
                this.createLoadAction(filterGroups, username),
            ];
        }))
    );

    afterUpdate$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdFiltersActions.update),
        withLatestFrom(this.appStore.select(ordFiltersReducer.selectFilterGroups), this.appStore.select(sharedEnvironmentReducer.selectUsername)),
        mergeMap(([action, filterGroups, username]) => {
            if (action.skipLoad) {
                console.log('[ORD TRACE] OrdFiltersActions.update skipped', {
                    at: new Date().toISOString(),
                });
                return [];
            }
            console.log('[ORD TRACE] OrdFiltersActions.update -> load', {
                at: new Date().toISOString(),
                username,
                activeFilters: filterGroups.filter((filterGroup) => filterGroup?.isActive).map((filterGroup) => filterGroup.key),
            });
            return [
                this.createLoadAction(filterGroups, username),
            ];
        }))
    );

     afterUpdateSingleFilter$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdFiltersActions.updateSingleFilter),
        withLatestFrom(this.appStore.select(ordFiltersReducer.selectFilterGroups), this.appStore.select(sharedEnvironmentReducer.selectUsername)),
        mergeMap(([action, filterGroups, username]) => {
            if (action.skipLoad) {
                console.log('[ORD TRACE] OrdFiltersActions.updateSingleFilter skipped', {
                    at: new Date().toISOString(),
                });
                return [];
            }
            console.log('[ORD TRACE] OrdFiltersActions.updateSingleFilter -> load', {
                at: new Date().toISOString(),
                username,
                activeFilters: filterGroups.filter((filterGroup) => filterGroup?.isActive).map((filterGroup) => filterGroup.key),
            });
            return [
                this.createLoadAction(filterGroups, username),
            ];
        }))
    );

    afterReset$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdFiltersActions.reset),
        mergeMap(_action => {
            console.log('[ORD TRACE] OrdFiltersActions.reset -> load', {
                at: new Date().toISOString(),
            });
            return [
                this.createLoadAction([], undefined),
            ];
        }))
    );

    afterUnset$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdFiltersActions.unSet),
        withLatestFrom(this.appStore.select(ordFiltersReducer.selectFilterGroups), this.appStore.select(sharedEnvironmentReducer.selectUsername)),
        mergeMap(([_action, filterGroups, username]) => {
            console.log('[ORD TRACE] OrdFiltersActions.unSet -> load', {
                at: new Date().toISOString(),
                username,
                activeFilters: filterGroups.filter((filterGroup) => filterGroup?.isActive).map((filterGroup) => filterGroup.key),
            });
            return [
                this.createLoadAction(filterGroups, username),
            ];
        }))
    );
}
